<script lang="ts">
  import { getContext } from 'svelte';
  import { css } from '@agapi/ui/panda/css';
  import { carouselStyles } from '../carousel.styles';
  import type { CarouselSlideProps } from '../carousel.types';

  const { fullWidth, children, css: cssProp }: CarouselSlideProps = $props();

  const context = getContext<{ count: number; reInit: () => void }>('carousel');
  context.count++;

  const classes = carouselStyles.raw({ fullWidth });
</script>

<div class={css(classes.slide, cssProp)}>
  {@render children?.()}
</div>
